export default {
    GET_CUTTING_JOBS_REQUEST: state => {
        state.cuttingJobsLoading = true
    },
    GET_CUTTING_JOBS_SUCCESS: (state, data) => {
        state.cuttingJobs = data.results
        state.cuttingJobsLoading = false
    },
    GET_CUTTING_JOBS_FAILURE: state => {
        state.cuttingJobsLoading = false
    },
    SET_CHANNELS: (state, data) => {
        state.channels = data.results
    },
    SET_STATUSES: (state, data) => {
        state.statuses = data.results
    },
    GENERATE_REPORT: state => {
        state.cuttingJobsLoading = true
    },
    GENERATE_REPORT_SUCCESS: state => {
        state.cuttingJobsLoading = false
    },
    GENERATE_REPORT_FAILURE: state => {
        state.cuttingJobsLoading = false
    }
}
